const checkClientValidVoucher = (voucherCode, env) => {
  // voucher code used in automation testing, will fail for special characters so return before check

  if (voucherCode === 'CVT-AUTOMATION-TESTING' && env !== 'prod') {
    return {
      shouldShowClientSideError: false,
      voucherErrorMessage: null,
    };
  }

  const validVoucherTest = /[^\w -]+|_/g;

  // Check here on client side if the voucher format is valid before sending off to validation service
  if (validVoucherTest.test(voucherCode)) {
    return {
      shouldShowClientSideError: true,
      voucherErrorMessage: 'Your voucher should only contain letters and numbers. Please check and try again.',
      ecd2EventLabel: 'Voucher Not AlphaNumeric',
    };
  }

  if (voucherCode.length < 20) {
    return {
      shouldShowClientSideError: true,
      voucherErrorMessage: 'Your voucher is too short. Please check and try again.',
      ecd2EventLabel: 'Voucher too short',
    };
  }

  if (voucherCode.length > 21) {
    return {
      shouldShowClientSideError: true,
      voucherErrorMessage: 'Your voucher is too long. Please check and try again.',
      ecd2EventLabel: 'Voucher too long',
    };
  }

  return {
    shouldShowClientSideError: false,
    voucherErrorMessage: null,
  };
};

export default checkClientValidVoucher;
